import { FactureService } from "./../_services/facture.service";
import { Component, OnInit } from "@angular/core";
import Swal from "sweetalert2";
import { Client, IClient } from './../models/Client.model';
import { ClientService } from './../_services/Client.service';
import { Commande } from "../models/Commande.model";
import { DetailCommande } from "../models/DetailCommande.model";
import { DomSanitizer } from "@angular/platform-browser";
import { CategorieService } from "../_services/Categorie.service";
import { Categorie } from "../models/Categorie.model";
import { ProduitService } from "../_services/Produit.service";
import { Produit } from "../models/Produit.model";
import { ActivatedRoute } from "@angular/router";
import { CommandeService } from "../_services/commande.service";
import { DetailscommandeService } from "../_services/detailscommande.service";
import { Adresse } from '../models/Adresse.model';
import { AdresseService } from '../_services/Adresse.service';
import { Paiement } from '../models/Paiement.model';
import { Facture } from '../models/Facture.model';
import { PaiementService } from '../_services/paiement.service';

@Component({
  selector: "app-commandeUpdate",
  templateUrl: "./commandeUpdate.component.html",
  styleUrls: ["./commandeUpdate.component.css"],
})
export class CommandeUpdateComponent implements OnInit {
  showinfosClient = false;
  showAddBtn = false;
  havePrix = false;
  LastItemOfTabCommand = false;
  dateLiv;
  items = [];
  adresse: Adresse;
  adresses: Adresse[] = [];
  //selected: { id: 0; libelle: "" }; pour tester
  selected: Categorie;
  items2 = [];
  selected2: Produit;
  avatar = "assets/img/avatars/user.png";
  productEmpty = "assets/img/avatars/emptyProduit.jfif";
  commande: Commande;
  detailcommande: DetailCommande;
  tabCommande = [];
  montantNetaPayer: number;
  montantTotal: number;
  montantTotalTemp: number = 0;
  montantTotalTempUpdate: number = 0;
  reduction: number;
  reductionUpdate: number = 0;
  telInput: any;
  clientData: Client;
  categories: Categorie[];
  produits: Produit[];
  CommandeUpdate: Commande;
  commandeCreatedId = 0;
  LivraisonAmount: number = 2000;
  montantTva: number
  paiement: Paiement;
  facture: Facture;
  avance = null
  constructor(
    private clientService: ClientService,
    private categorieService: CategorieService,
    private produitService: ProduitService,
    private commandeService: CommandeService,
    private detailscommandeService: DetailscommandeService,
    private factureService: FactureService,
    private paiementService: PaiementService,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private adresseService: AdresseService
  ) {}

  ngOnInit() {
    if (!this.route.snapshot.paramMap.get("id")) {
      this.commande = new Commande();
      this.paiement = new Paiement();
      this.facture = new Facture();
      this.detailcommande = new DetailCommande();
      this.selected2 = new Produit();
      this.LoadCategorieSelect();
      this.montantTotal = null;
    } else {
      this.showAddBtn = !this.showAddBtn;
      //this.commande = new Commande();
      this.detailcommande = new DetailCommande();
      this.adresse = new Adresse();
      this.selected2 = new Produit();
      this.selected = new Categorie();
      this.LoadCategorieSelect();
      this.commandeService
        .getOneData(this.route.snapshot.paramMap.get("id"))
        .subscribe((CommandeData: Commande) => {
          console.log(CommandeData);
          this.commande = CommandeData;
          this.CommandeUpdate = CommandeData;
          this.clientData = this.commande.client;

          this.telInput = this.commande.client.tel;
          this.montantTotal = this.commande.montant;

          if (this.commande.reduction != null) {
            this.montantNetaPayer =
              this.commande.montant - this.commande.reduction;
            this.reduction = this.commande.reduction;
          } else {
            this.montantNetaPayer = this.commande.montant;
          }
          this.showinfosClient = true;
          this.LoadTabDetailsCommande(CommandeData);
          this.adresseService
        .getAllAdresseByClient(this.clientData.id)
        .subscribe((data: Adresse[]) => {
          this.adresses = data;
          console.log("Adresses Client",this.adresses);
        });
        });

    }
     ///////
     var pageHeader = $(".content-header").find("b");
     var adminForm = $(".admin-form");
     var buttons = adminForm.find(".button");
     var Panel = adminForm.find(".panel");
     setTimeout(function () {
       adminForm.addClass("theme-success");
       Panel.addClass("panel-success");
       pageHeader.addClass("text-success");

       buttons.removeClass().addClass("button btn-success");
     }, 800);
     //////
  }
  getClientDataByTel() {
    this.clientService
      .getClientByTel(this.telInput)
      .subscribe((data: Client) => {
        this.clientData = data;
        console.log(this.clientData);
        this.showinfosClient = true;
      });
  }
  LoadCategorieSelect() {
    this.categorieService.getData().subscribe((data: Categorie[]) => {
      this.categories = data;
      this.items = this.categories;
    });
  }
  LoadProduitSelectByCategorie(id) {
    this.produitService
      .getProduitByCategorie(id)
      .subscribe((data: Produit[]) => {
        this.produits = data;
        this.items2 = this.produits;
        //console.log(this.items2);
      });
  }
  getValues() {
    console.log(this.selected);
    //console.log(this.selected.id);
    this.selected2 = new Produit();
    this.LoadProduitSelectByCategorie(this.selected.id);
  }
  getValues2() {
    console.log(this.selected2);
    this.havePrix = true;
  }
  /**Cette fonction permet d'ajouter une réduction à la commande */
  AddReduction() {
    console.log(this.reduction);
    //this.montantTotal = 0;
    //this.montantNetaPayer = 0;
    if (this.reduction) {
      // Cas update sinon ajout
      this.montantTotal = 0;
      this.montantNetaPayer = 0;
      if (this.route.snapshot.paramMap.get("id")) {
        for (let c of this.tabCommande) {
          this.montantTotal += c.qte * c.prix;
        }
        console.log(
          "Have Reduct Montant somme prix cas update",
          this.montantTotal
        );
        this.montantNetaPayer = this.montantTotal - this.reduction;
        //this.commande.avance = (this.montantTotal * 60) / 100;
      } else {
        for (let c of this.tabCommande) {
          this.montantTotal += c.qte * c.prix;
        }
        this.montantNetaPayer = this.montantTotal - this.reduction;
        //this.commande.avance = (this.montantTotal * 60) / 100;
      }
    } else {
      // Cas update sinon ajout
      this.montantTotal = 0;
      this.montantNetaPayer = 0;
      if (this.route.snapshot.paramMap.get("id")) {
        for (let c of this.tabCommande) {
          this.montantTotal += c.qte * c.prix;
        }
        console.log(
          "Doesn't have reduct Montant somme prix cas update",
          this.montantTotal
        );
        this.montantTotalTemp = this.montantTotal;
        this.montantNetaPayer = this.montantTotal;
        //this.commande.avance = (this.montantTotal * 60) / 100;
      } else {
        for (let c of this.tabCommande) {
          this.montantTotal += c.qte * c.prix;
        }
        //this.montantTotal = this.montantTotalTemp;
        this.montantNetaPayer = this.montantTotal;
        //this.montantNetaPayer = this.montantTotalTempUpdate;
        //this.commande.avance = (this.montantTotal * 60) / 100;
      }
    }
  }
  /**End AddReduction */
  /**
   * Cette fonction permet d'ajouter une commande dans le tableau de commande
   */
  AddCommandeOnTab() {
    this.tabCommande.push({
      produit: this.selected2.libelle,
      image: this.selected2.image,
      categorie: this.selected.libelle,
      commentaire: this.detailcommande.commentaire,
      qte: this.detailcommande.qte,
      prix: this.selected2.prixUnitaire,
      produitObject: this.selected2,
    });
    this.montantTotal = 0;
    this.montantNetaPayer = 0;
    for (let c of this.tabCommande) {
      this.montantTotal += c.qte * c.prix;
    }
    this.montantTotalTempUpdate = this.montantTotal;
    //this.montantNetaPayer = this.montantTotal;
    this.clearChamp();
    // Cas Udpdate
    if (this.reduction) {
      this.montantNetaPayer = this.montantTotal - this.reduction;
      //this.commande.avance = (this.montantTotal * 60) / 100;
    } else {
      this.montantTotal = this.montantTotalTempUpdate;
      this.montantNetaPayer = this.montantTotal;
      //this.commande.avance = (this.montantTotal * 60) / 100;
    }
  }
  /**End AddCommandeOnTab */

  /**Cette fonction permet de vider les champs
   * après l'appel de la fonction AddCommandeOnTab
   */
  clearChamp() {
    this.detailcommande.commentaire = "";
    this.detailcommande.qte = 0;
    this.selected = new Categorie();
    this.selected2 = new Produit();
  }
  /**End clearChamp */

  /**La première LoadTabCommandeOnUpdate fonction permet de charger la commande
   * puis de le passer à la deuxième fonction
   * LoadTabDetailsCommande qui
   * permet de charger les détails de la commande
   * d'un client dans le tableau de commande
   * lors de l'update tout en recalculant
   * le montantTotal,le montantNetàpayer avec la reduction
   */
  LoadTabCommandeOnUpdate() {
    this.tabCommande.length = 0;
    this.commandeService
      .getOneData(this.route.snapshot.paramMap.get("id"))
      .subscribe((CommandeData: Commande) => {
        console.log(CommandeData);
        this.commande = CommandeData;
        this.LoadTabDetailsCommande(CommandeData);
      });
  }
  LoadTabDetailsCommande(DataCommande: Commande) {
    console.log(DataCommande);
    for (let details of DataCommande.details_commandes) {
      this.tabCommande.push({
        produit: details.produit.libelle,
        image: details.produit.image,
        categorie: details.produit.categorie.libelle,
        commentaire: details.commentaire,
        qte: details.qte,
        prix: details.produit.prixUnitaire,
        produitObject: details.produit,
        IdDetailCommande: details.id,
      });
    }
    //this.montantTotal = DataCommande.montant;
    this.montantTotal = 0;
    for (let c of this.tabCommande) {
      this.montantTotal += c.qte * c.prix;
    }
    this.montantTotalTempUpdate = this.montantTotal;
    //this.montantNetaPayer = this.montantTotal;
    this.clearChamp();
    // Cas Udpdate
    if (this.reduction) {
      this.montantNetaPayer = this.montantTotal - this.reduction;
      //this.commande.avance = (this.montantTotal * 60) / 100;
    } else {
      //New Change
      this.montantTva = ((this.montantTotalTempUpdate + this.LivraisonAmount)/100)*18;
      this.montantTotal = this.montantTotalTempUpdate + this.LivraisonAmount + this.montantTva;
      this.montantNetaPayer =this.montantTotal - this.CommandeUpdate.avance;
      //Last Change
      //this.montantTotal = this.montantTotalTempUpdate;
      // this.montantNetaPayer = this.montantTotal
    }
  }
  /**End LoadTabCommande */

  /**Cette fonction insertDetailCommande permet d'insérer
   * de nouveaux produits dans la commande en
   * cours lors de l'update d'une commande
   */
  insertDetailCommande() {
    this.detailcommande.produit = this.selected2;
    this.detailcommande.commande = this.CommandeUpdate;
    //this.detailcommande.commande =
    console.log("InsertingDetailCommande", this.detailcommande);
    this.detailscommandeService
      .insertData(this.detailcommande)
      .subscribe((DetailCommandeCreated) => {
        console.log("DetailCommandeCreated", DetailCommandeCreated);
        this.LoadTabCommandeOnUpdate();
        this.clearChamp();
      });
  }
  /**End insertDetailCommande */

  /**Cette fonction deleteDetailCommande permet
   * de supprimer ce détails(produits) de
   * la commande
   */
  deleteDetailCommande(id) {
    this.detailscommandeService.deleteData(id).subscribe(() => {
      console.log("Détails supprimer de la commande");
      this.LoadTabCommandeOnUpdate();
    });
  }
  /**End insertDetailCommande */

  /**Cette fonction insertData permet d'insérer
   * une commande avec ses détails et
   * de faire aussi l'update d'une commande
   */
  insertData() {
    if (this.route.snapshot.paramMap.get("id")) {
      const date = new Date(this.commande.dateLiv).toLocaleDateString();
      this.commande.dateLivFormat = date;
      this.montantTva = ((this.montantTotal + this.LivraisonAmount)/100)*18;
      this.commande.montant = this.montantTotal + this.LivraisonAmount + this.montantTva;
      //this.commande.montant = this.montantTotal;
      this.commande.reduction = this.reduction;
      if (this.avance == null) {
        this.commande.avance = this.commande.montant;
        this.paiement.datePaiement = new Date();
        this.paiement.type = 'Complet';
        this.paiement.montant = this.commande.montant;
      } else {
        this.commande.avance = this.avance;
        this.paiement.datePaiement = new Date();
        this.paiement.type = 'Avance';
        this.paiement.montant = this.avance;
      }
      // for(let c of this.adresses){
      //   this.clientData.adresses = [];
      //   c.client = this.clientData;
      // }
      // console.log("Adresses", this.adresses);
      // this.commande.client.adresses = [];
      // this.commande.client.adresses = this.adresses;
      // console.log("Client", this.commande.client);
      this.commande.client.adresses = [];
      this.commandeService
        .updateData(this.route.snapshot.paramMap.get("id"), this.commande)
        .subscribe(() => {
          console.log("Update avec succes");
          for (let a of this.adresses) {
            console.log(a);
            this.adresse = a;
            this.adresse.client = this.clientData;
            console.log('Updating Adresse', this.adresse);
            this.adresseService.updateData( this.adresse.id,this.adresse).subscribe((data) => {
              console.log('Updated Adresse', data);
            });
          }
          window.history.back();
        });
    } else {
      this.commande.id = null;
      this.commande.client = this.clientData;
      const date = new Date(this.commande.dateLiv).toLocaleDateString();
      this.commande.dateLivFormat = date;
      this.montantTva = ((this.montantTotal + this.LivraisonAmount)/100)*18;
      this.commande.montant = this.montantTotal + this.LivraisonAmount + this.montantTva;
      //this.commande.montant = this.montantTotal;
      if (this.reduction == null) {
        this.commande.reduction = 0.0;
      } else {
        this.commande.reduction = this.reduction;
      }
      this.commande.avance = 0.0;
      this.commande.etat = "En cours";
      console.log("Commande", this.commande);
      this.commandeService
        .insertData(this.commande)
        .subscribe((commandeCreated: Commande) => {
          console.log("CommandeCreated", commandeCreated);
          if (commandeCreated) {
            this.commandeCreatedId = commandeCreated.id;
            /*for (let c of this.tabCommande) {
              this.detailcommande.produit = c.produitObject;
              this.detailcommande.commande = commandeCreated;
              this.detailcommande.qte = c.qte;
              this.detailcommande.commentaire = c.commentaire;
              this.detailscommandeService
                .insertData(this.detailcommande)
                .subscribe((DetailCommandeCreated) => {
                  console.log("DetailCommandeCreated", DetailCommandeCreated);
                });
              if ((i + 1) == this.tabCommande.length - 1) {
                console.log("Dernier élément tab");
              }
              //console.log("Object", c);
              // console.log("Pop Command", );
            }*/
            let completedCount = 0;
            for (var i = 0; i < this.tabCommande.length; i++) {
              this.detailcommande.produit = this.tabCommande[i].produitObject;
              this.detailcommande.commande = commandeCreated;
              this.detailcommande.qte = this.tabCommande[i].qte;
              this.detailcommande.commentaire = this.tabCommande[i].commentaire;
              this.detailscommandeService
                .insertData(this.detailcommande)
                .subscribe((DetailCommandeCreated) => {
                  console.log("DetailCommandeCreated", DetailCommandeCreated);
                });

              completedCount += 1;

              // Do something if is the last iteration of the array
              /*if (i + 1 == this.tabCommande.length) {
                this.LastItemOfTabCommand = true;
                console.log(
                  "Last iteration with item : " +
                    this.tabCommande[i].produitObject.libelle
                );
              }*/
              if (completedCount === this.tabCommande.length) {
                console.log("Boucle Complete");
                console.log("Commande Id", this.commandeCreatedId);
                this.paiementService
                      .insertData(this.paiement)
                      .subscribe((paiementCreated) => {
                        console.log("paiementCreated",paiementCreated);
                        if(paiementCreated){
                           //Creation Facture
                          this.facture.dateFact = new Date();
                          this.facture.commande = commandeCreated;
                          //this.facture.numero = '1';
                          this.facture.paiement = paiementCreated;
                          console.log("InsertedFacture", this.facture);
                              this.factureService
                          .insertData(this.facture)
                          .subscribe((factureCreated) => {
                            console.log("factureCreated",factureCreated);
                            //this.spinner.hide();
                            //localStorage.removeItem("cartItem");
                            window.history.back();
                            /*this.router.navigateByUrl('/pages/order/'+commandeCreated.numero)
                            .then(() => {
                              window.location.reload();
                            });*/
                          });
                        }
                      });
              }
            }
          }
        });
    }
  }

  fetchData() {
    const promise = this.produitService.getData().toPromise();
    console.log(promise);
    promise
      .then((data) => {
        console.log("Promise resolved with: " + JSON.stringify(data));
      })
      .catch((error) => {
        console.log("Promise rejected with " + JSON.stringify(error));
      });
  }
  precedentPage() {
    window.history.back();
  }
  AlertNumberNotFound() {
    Swal.fire({ title: "Ce numéro n'existe pas veuillez réessayer !!!" }).then(
      (result) => {
        if (result.value) {
          // handle Confirm button click
          // result.value will contain `true` or the input value
        } else {
          // handle dismissals
          // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
        }
      }
    );
  }

  CommandeAnnuler() {
    Swal.fire({ title: "Commande annuler avec succés" }).then((result) => {
      if (result.value) {
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }
  AlertDeleteDetailsCommande(id) {
    Swal.fire({
      title: "Êtes-vous sûr de vouloir supprimer ce produit de la commande?",
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteDetailCommande(id);
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }
}
